import * as customPropTypes from '@fluentui/react-proptypes';
import * as PropTypes from 'prop-types';
import { compose } from '@fluentui/react-bindings';
import { commonPropTypes } from '../../utils';
import { SkeletonShape } from './SkeletonShape';
export var skeletonButtonClassName = 'ui-skeleton__button';
/**
 * An SkeletonButton represents a buton component that will be loaded
 */

export var SkeletonButton = /*#__PURE__*/function () {
  var SkeletonButton = compose(SkeletonShape, {
    className: skeletonButtonClassName,
    displayName: 'SkeletonButton',
    overrideStyles: true,
    shorthandConfig: {},
    handledProps: ['size', 'circular', 'iconOnly', 'fluid'],
    mapPropsToStylesProps: function mapPropsToStylesProps(_ref) {
      var size = _ref.size,
          fluid = _ref.fluid,
          iconOnly = _ref.iconOnly,
          circular = _ref.circular;
      return {
        size: size,
        fluid: fluid,
        iconOnly: iconOnly,
        circular: circular
      };
    }
  });
  SkeletonButton.propTypes = Object.assign({}, commonPropTypes.createCommon(), {
    size: customPropTypes.size,
    circular: PropTypes.bool,
    iconOnly: PropTypes.bool,
    fluid: PropTypes.bool
  });
  SkeletonButton.defaultProps = {
    as: 'span',
    size: 'medium'
  };
  return SkeletonButton;
}();
//# sourceMappingURL=SkeletonButton.js.map
